module.exports = __webpack_public_path__ + "img/Colorization9.20616270.webp";